import React, { useContext, useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  ActivityLayout,
  ActivityTimer,
  ActivityProgress,
  useActivityData,
  activityApiService,
  formatTime,
  generateRemarks
} from "../shared";
import { UserContext } from "../../UserContext";
import { fetchActivitiesImage } from "../fetchActivitiesImage";
import "./SpeedQuizActivity.css";

import MCQActivityImage from "./mental-activity.png";
import GoodImage from "./good.png";
import CrossImage from "./cross.png";
import FinishedImage from "./finished.jpeg";
import axios from "axios";
// import AdminNav from '../../Navbars/AdminNav'
// import Footer from '../../Footer'

const SpeedQuizActivity = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activityId = searchParams.get("activityId");

  // Use shared activity data hook
  const {
    actualQuestions,
    currQuestion,
    count,
    totalQuestions,
    marksPerQuestion,
    totalMarks,
    questionNumber,
    gainedMarks,
    items,
    studentId,
    setCount,
    setQuestionNumber,
    setCurrQuestion,
    setMarksPerQuestion,
    setItems,
    setGainedMarks,
    countRef,
    totalQuestionsRef,
    progressIncrement,
    questionNumberRef,
    progressCount,
    gainedMarksRef,
    totalTimeTakenOfAllQuestions,
    totalTimeOfAllQuestions,
    completeActivityRef
  } = useActivityData(activityId);

  // SpeedQuiz specific state
  const [imageData, setImageData] = useState(null);
  const [studentAnswer, setStudentAnswer] = useState("");
  const [isActivityComplete, setIsActivityComplete] = useState(false);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);

  // Refs for SpeedQuiz specific elements
  const hoursRef = useRef(0);
  const minutesRef = useRef(0);
  const ProgressRef = useRef(null);

  // Fetch image data when current question changes
  useEffect(() => {
    if (currQuestion?.questionpicture) {
      fetchActivitiesImage(setImageData, currQuestion.questionpicture);
    }
  }, [currQuestion]);

  // Fetch activity time for SpeedQuiz
  useEffect(() => {
    const fetchActivityTime = async () => {
      try {
        const timeResponse = await activityApiService.getActivityTime(activityId);
        const totalTime = timeResponse.data[0].TotalTime;

        var calculatedHours = Math.floor(totalTime / 60);
        var calculatedMinutes = totalTime % 60;

        if (calculatedMinutes === 0 && calculatedHours > 0) {
          calculatedHours = calculatedHours - 1;
          calculatedMinutes = 60;
        }

        setCount(60);
        countRef.current = 60;
        setMinutes(calculatedMinutes - 1);
        minutesRef.current = calculatedMinutes - 1;
        setHours(calculatedHours);
        hoursRef.current = calculatedHours;
      } catch (error) {
        console.error('Error fetching activity time:', error);
      }
    };

    if (activityId) {
      fetchActivityTime();
    }
  }, [activityId]);

  const submitButton = useRef(null);
  const GoodImageRef = useRef(null);
  const CrossImageRef = useRef(null);
  const FinishedImageRef = useRef(null);

  const optionRef1 = useRef(null);
  const optionRef2 = useRef(null);
  const optionRef3 = useRef(null);
  const optionRef4 = useRef(null);

  const studentCurrAnswerRef = useRef(0);
  const marksObtainedCurrQuestionRef = useRef(0);
  const isCorrectRef = useRef(0);
  // const progressIncrement = useRef((100/(totalQuestionsRef.current))*1.3);

  console.log("progress Increment is: ", progressIncrement.current);

  function stopIntervalID() {
    setCount(0);
    countRef.current = 0;
    setMinutes(0);
    minutesRef.current = 0;
    setHours(0);
    hoursRef.current = 0;

    clearInterval(intervalId);

    studentCurrAnswerRef.current = "";
    marksObtainedCurrQuestionRef.current = marksPerQuestion;
    isCorrectRef.current = 0;
    submitStudentQuestionResponse();

    setItems([...items, 0]);
    clearInterval(intervalId);

    if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
    if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

    if (submitButton.current) submitButton.current.style.display = "none";
    if (FinishedImageRef.current) FinishedImageRef.current.style.display = "inline-block";
  }

  var intervalId;
  useEffect(() => {
    // Don't start timer if activity is completed
    if (isActivityComplete) {
      return;
    }

    intervalId = setInterval(() => {
      countRef.current = countRef.current - 1;
      if (countRef.current === -1) {
        // studentCurrAnswerRef.current = "";
        // marksObtainedCurrQuestionRef.current = marksPerQuestion;
        // isCorrectRef.current = 0;

        // submitStudentQuestionResponse();

        setMinutes((minutes) => minutes - 1);
        minutesRef.current -= 1;

        if (minutesRef.current === -1 && hoursRef.current === 0) {
          stopIntervalID();
        }

        console.log("Minutes ");

        if (minutesRef.current > 0) {
          setCount(59);
          countRef.current = 59;
        }

        // if(minutesRef.current === 0 && hoursRef.current === 0){
        //     setCount(59);
        //     countRef.current = 59;
        // }

        if (minutesRef.current < 0 && hoursRef.current > 0) {
          setHours((hours) => hours - 1);
          hoursRef.current -= 1;

          setMinutes(59);
          minutesRef.current = 59;

          setCount(59);
          countRef.current = 59;
        }

        // Check if this is the last question before moving to next
        if (questionNumberRef.current < totalQuestions - 1) {
          questionNumberRef.current = questionNumberRef.current + 1;
          setQuestionNumber(questionNumber => questionNumber + 1);
          setCurrQuestion(actualQuestions[questionNumberRef.current]);
          setMarksPerQuestion(actualQuestions[questionNumberRef.current].marks);
          setCount(actualQuestions[questionNumberRef.current].timealloted);
          setItems([...items, 0]);
          countRef.current = actualQuestions[questionNumberRef.current].timealloted;
          GoodImageRef.current.style.display = 'none';
          if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";
        } else {
          // Last question - handle completion
          setItems([...items, 0]);
          GoodImageRef.current.style.display = 'none';
          if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";
          if (submitButton.current) submitButton.current.style.display = "none";
          if (FinishedImageRef.current) FinishedImageRef.current.style.display = "inline-block";

          // Submit final question response
          studentCurrAnswerRef.current = "";
          marksObtainedCurrQuestionRef.current = 0;
          isCorrectRef.current = 0;
          submitStudentQuestionResponse();

          // Complete activity
          completeActivityRef.current = 1;
          submitCompleteActivityResponse();

          // Stop timer and mark activity as complete
          clearInterval(intervalId);
          setIsActivityComplete(true);
        }
      } else {
        setCount(countRef.current);
      }
    }, 1000);

    // Return a cleanup function to clear the interval
    return () => clearInterval(intervalId);
  }, [questionNumber, count]);

  useEffect(() => {
    if (
      questionNumber == totalQuestions &&
      count == 0 &&
      minutes == 0 &&
      hours == 0
    ) {
      studentCurrAnswerRef.current = "";
      marksObtainedCurrQuestionRef.current = marksPerQuestion;
      isCorrectRef.current = 0;
      submitStudentQuestionResponse();

      setItems([...items, 0]);
      clearInterval(intervalId);

      if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
      if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

      if (submitButton.current) submitButton.current.style.display = "none";
      if (FinishedImageRef.current) FinishedImageRef.current.style.display = "inline-block";
      setIsActivityComplete(true);
    }
  }, [questionNumber, count]);

  const handleStudentAnswer = (event) => {
    setStudentAnswer(event.target.value);
  };


  const submitStudentQuestionResponse = async () => {
    totalTimeTakenOfAllQuestions.current +=
      currQuestion?.timealloted - countRef.current - 1;
    totalTimeOfAllQuestions.current += currQuestion?.timealloted;

    try {
      await activityApiService.saveActivityQuestion({
        Question_id: currQuestion?.Question_id,
        Student_id: studentId,
        timetaken: currQuestion?.timealloted - countRef.current - 1,
        StudentAnswer: studentCurrAnswerRef.current,
        MarksObtained: marksObtainedCurrQuestionRef.current,
        TotalTime: currQuestion?.timealloted,
        correct: isCorrectRef.current,
      });

      await activityApiService.saveActivity({
        Activity_id: activityId,
        Student_id: studentId,
        MarksObtained: gainedMarksRef.current,
        MarksObtainedPercentage: (gainedMarksRef.current / totalMarks) * 100,
        Remarks: generateRemarks((gainedMarksRef.current / totalMarks) * 100),
        SubmitActivityFile: "",
        TimeTaken: totalTimeTakenOfAllQuestions.current,
        TotalMarks: totalMarks,
        TotalTime:
          totalTimeOfAllQuestions.current < 0
            ? 0
            : totalTimeOfAllQuestions.current,
        Complete: 0,
      });
    } catch (error) {
      console.error('Error submitting response:', error);
    }
  };


  const submitCompleteActivityResponse = async () => {
    try {
      await activityApiService.saveActivity({
        Activity_id: activityId,
        Student_id: studentId,
        MarksObtained: gainedMarksRef.current,
        MarksObtainedPercentage: (gainedMarksRef.current / totalMarks) * 100,
        Remarks: "Good Efforts",
        SubmitActivityFile: "",
        TimeTaken: totalTimeTakenOfAllQuestions.current,
        TotalMarks: totalMarks,
        TotalTime: totalTimeOfAllQuestions.current,
        Complete: completeActivityRef.current,
      });
    } catch (error) {
      console.error('Error submitting complete activity:', error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(studentAnswer);
    // Check if any option is selected
    if (
      !optionRef1.current.checked &&
      !optionRef2.current.checked &&
      !optionRef3.current.checked &&
      !optionRef4.current.checked
    ) {
      alert("Please select an answer before submitting!");
      return;
    }
    console.log("I am in handle submit...");

    if (questionNumber === totalQuestions) {
      if (
        optionRef1.current.checked &&
        currQuestion?.option1 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option1;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else if (
        optionRef2.current.checked &&
        currQuestion?.option2 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option2;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else if (
        optionRef3.current.checked &&
        currQuestion?.option3 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option3;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else if (
        optionRef4.current.checked &&
        currQuestion?.option4 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option4;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else {
        setItems([...items, 0]);
        if (GoodImageRef.current) if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
        if (CrossImageRef.current) if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

        if (optionRef1.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option1;
        } else if (optionRef2.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option2;
        } else if (optionRef3.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option3;
        } else if (optionRef4.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option4;
        }
        marksObtainedCurrQuestionRef.current = 0;
        isCorrectRef.current = 0;

        submitStudentQuestionResponse();
      }

      clearInterval(intervalId);
      if (submitButton.current) submitButton.current.style.display = "none";
      if (FinishedImageRef.current) FinishedImageRef.current.style.display = "inline-block";

      progressCount.current += progressIncrement.current;
      if (ProgressRef.current) ProgressRef.current.style.width = `${progressCount.current}px`;

      completeActivityRef.current = 1;
      submitCompleteActivityResponse();
      setIsActivityComplete(true);
    } else {
      if (
        optionRef1.current.checked &&
        currQuestion?.option1 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option1;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else if (
        optionRef2.current.checked &&
        currQuestion?.option2 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option2;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else if (
        optionRef3.current.checked &&
        currQuestion?.option3 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option3;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else if (
        optionRef4.current.checked &&
        currQuestion?.option4 == currQuestion?.correctanswer
      ) {
        setItems([...items, 1]);
        gainedMarksRef.current = gainedMarksRef.current + marksPerQuestion;
        setGainedMarks((gainedMarks) => gainedMarks + marksPerQuestion);
        if (CrossImageRef.current) CrossImageRef.current.style.display = "none";
        if (GoodImageRef.current) GoodImageRef.current.style.display = "inline-block";

        studentCurrAnswerRef.current = currQuestion?.option4;
        marksObtainedCurrQuestionRef.current = marksPerQuestion;
        isCorrectRef.current = 1;

        submitStudentQuestionResponse();
      } else {
        setItems([...items, 0]);
        if (GoodImageRef.current) if (GoodImageRef.current) GoodImageRef.current.style.display = "none";
        if (CrossImageRef.current) if (CrossImageRef.current) CrossImageRef.current.style.display = "inline-block";

        if (optionRef1.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option1;
        } else if (optionRef2.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option2;
        } else if (optionRef3.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option3;
        } else if (optionRef4.current.checked) {
          studentCurrAnswerRef.current = currQuestion?.option4;
        }

        marksObtainedCurrQuestionRef.current = 0;
        isCorrectRef.current = 0;

        submitStudentQuestionResponse();
      }
      questionNumberRef.current = questionNumberRef.current + 1;
      setQuestionNumber((questionNumber) => questionNumber + 1);
      setCurrQuestion(actualQuestions[questionNumberRef.current]);
      console.log("..........Calling Fetch Image..........");
      fetchActivitiesImage(
        setImageData,
        actualQuestions[questionNumberRef.current]?.questionpicture
      );
      setMarksPerQuestion(actualQuestions[questionNumberRef.current]?.marks);

      // setCount(actualQuestions[questionNumberRef.current].timealloted);
      // countRef.current = actualQuestions[questionNumberRef.current].timealloted;

      optionRef1.current.checked = false;
      optionRef2.current.checked = false;
      optionRef3.current.checked = false;
      optionRef4.current.checked = false;

      progressCount.current += progressIncrement.current;
      if (ProgressRef.current) ProgressRef.current.style.width = `${progressCount.current}px`;
    }
    setCount(60);
    countRef.current = 60;
  };


  const { userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    });
    navigate("/");
  };

  const handleCourseSelect = (course) => {
    console.log("Selected Course:", course);
  };


  // Add this after activity completion
  if (window.opener) {
    window.opener.postMessage("activityCompleted", "*");
  }

  return (
    <ActivityLayout
      title="Speed Quiz Activity"
      onLogout={onLogout}
      onCourseSelect={handleCourseSelect}
    >
      <div className="MAMheading">
        <div className="MAMactivity-image">
          <img src={MCQActivityImage} alt="" />
        </div>

        <div className="MAMactivity-text">
          <h3>{currQuestion?.ActivityName}</h3>
        </div>
      </div>

      <div className="MAMcontainer">
        <div className="MAMbody">
          <div className="left-column">
            <div className="question-tracker">
              <p>
                {currQuestion?.ActivityType == "Video" ? "Video" : "Question"}{" "}
                <span className="question-number">#{questionNumber}</span>
              </p>
              <ActivityProgress
                current={questionNumber}
                total={totalQuestions}
                progress={(questionNumber / totalQuestions) * 100}
              />
            </div>
            <div className="mobile-timer">
              <ActivityTimer count={count} displayFormat="box" />
            </div>
            <div class="play-area">
              <div class="MAMCQmcq-text">
                <h4 className="mcqqstn">
                  Q:{" "}
                  <span id="MAMCQmental-question-text">
                    {currQuestion?.question}
                  </span>
                </h4>
              </div>

              <div className="MAMCQmcq-options">
                <div>
                  <input
                    type="radio"
                    className="mcq-radio"
                    ref={optionRef1}
                    id={"option1"}
                    name="mcq"
                    value={currQuestion?.option1}
                    style={{ width: "20px", marginRight: "20px" }}
                  />
                  <label for={"option1"} className="mcq-option-label">
                    {" "}
                    {currQuestion?.option1}
                  </label>
                  <br />
                </div>
                <div>
                  <input
                    type="radio"
                    className="mcq-radio"
                    ref={optionRef2}
                    id={"option2"}
                    name="mcq"
                    value={currQuestion?.option2}
                    style={{ width: "20px", marginRight: "20px" }}
                  />
                  <label for={"option2"} className="mcq-option-label">
                    {" "}
                    {currQuestion?.option2}
                  </label>
                  <br />
                </div>
                <div>
                  <input
                    type="radio"
                    className="mcq-radio"
                    ref={optionRef3}
                    id={"option3"}
                    name="mcq"
                    value={currQuestion?.option3}
                    style={{ width: "20px", marginRight: "20px" }}
                  />
                  <label for={"option3"} className="mcq-option-label">
                    {" "}
                    {currQuestion?.option3}
                  </label>
                  <br />
                </div>
                {currQuestion?.option4 && <div>
                  <input
                    type="radio"
                    className="mcq-radio"
                    ref={optionRef4}
                    id={"option4"}
                    name="mcq"
                    value={currQuestion?.option4}
                    style={{ width: "20px", marginRight: "20px" }}
                  />
                  <label for={"option4"} className="mcq-option-label">
                    {" "}
                    {currQuestion?.option4}
                  </label>
                  <br />
                </div>}
              </div>
              <div class="MAMCQplay-button">
                <button
                  ref={submitButton}
                  className="SQAsubmitButton"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
            <div class="MApicture">
              {imageData ? (
                <img
                  src={imageData}
                  alt="Question Image"
                />
              ) : (
                <p></p>
              )}
            </div>
            <div className="MAMCQremarks">
              <div className="MAMCQcorrect-wrong-picture">
                <img
                  id="MAremarksId"
                  src={GoodImage}
                  ref={GoodImageRef}
                  alt=""
                  style={{ width: "100px", display: "none" }}
                />
                <img
                  id="remarksId"
                  src={CrossImage}
                  ref={CrossImageRef}
                  alt=""
                  style={{ width: "100px", display: "none" }}
                />
              </div>

              <div className="MAMCQfinished-picture">
                <img
                  id="finishedId"
                  src={FinishedImage}
                  ref={FinishedImageRef}
                  alt=""
                  style={{ width: "100px", display: "none" }}
                />
              </div>
            </div>
          </div>

          <div className="right-column">
            <div className="desktop-timer">
              <ActivityTimer count={count} displayFormat="box" />
            </div>
            <div id="MAmarks-color">
              <h3 className="MAMscoreHeading">Score</h3>
              <h3 className="MAMscoreHeading" style={{ display: "flex" }}>
                <span id="MAOcurrent-score">{gainedMarks}</span> /
                <span id="MAOtotal-score">{totalMarks}</span>
              </h3>
              {items.map((item, index) => (
                <div className="MAbox">
                  <div className="MAbox1">
                    <h3>{(index + 1).toString().padStart(2, "0")}</h3>
                  </div>
                  <div className={`MAbox2${item}`}>
                    {item === 1 ? "✓" : "✗"}
                  </div>
                </div>
              ))}
            </div>
            {currQuestion?.instructions && (
              <div className="">
                <span
                  style={{
                    color: "#b8860b",
                    fontWeight: "bold",
                    cursor: "pointer",
                    borderRadius: "6px",
                    padding: "6px 12px",
                    display: "inline-block",
                    margin: "8px 0",
                    display: "flex"
                  }}
                  onClick={() => {
                    window.alert(currQuestion?.instructions);
                  }}
                >
                  Read instruction
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className="leaderboard-button-container"
        style={{ textAlign: "center", margin: "20px" }}
      >
        <button
          onClick={() => navigate(`/leaderboard?activityId=${activityId}`)}
          className="leaderboard-button"
          style={{
            padding: "10px 20px",
            backgroundColor: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          View Leaderboard
        </button>
      </div>
    </ActivityLayout>
  );
};

export default SpeedQuizActivity;
